// extracted by mini-css-extract-plugin
export default {"root":"RedAdterisk_root__GJnZ7","redAdterisk":"RedAdterisk_redAdterisk__G1Asr"};